export const TOTAL_COLUMN_WIDTH = 140
export const AMOUNT_APPLIED_COLUMN_WIDTH = 120
